import type { SVGProps } from 'react';
import { Ref, forwardRef, memo } from 'react';
const IconUserRound = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    aria-label="IconUserRound"
    fill="currentColor"
    ref={ref}
    {...props}
  >
    <path d="M12 0a12 12 0 1 0 0 24 12 12 0 0 0 0-24M8.934 6.923a4.16 4.16 0 0 1 3.058-1.24 4.236 4.236 0 0 1 4.3 4.3 4.237 4.237 0 0 1-4.3 4.3 4.237 4.237 0 0 1-4.3-4.3 4.14 4.14 0 0 1 1.24-3.058m3.058 14.971a9.88 9.88 0 0 1-7.59-3.538A15.6 15.6 0 0 1 8.051 16.6c1.275-.4 2.604-.599 3.94-.588a12.8 12.8 0 0 1 3.935.588c1.29.43 2.523 1.012 3.674 1.735a9.89 9.89 0 0 1-7.6 3.56" />
  </svg>
);
const ForwardRef = /* #__PURE__ */ forwardRef(IconUserRound);
const Memo = /* #__PURE__ */ memo(ForwardRef);
export default Memo;
